import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App";
import "./styles.css";
import "./workspace-oasis.css";

const root = document.getElementById("root");

if (!root) {
  throw new Error("The app could not find its page root.");
}

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
